<template>
  <v-container fluid pa-0>
    <v-row>
      <!-- Date range -->

      <v-col cols="12">
        <helpers-section-sub-header>E-mail notifications</helpers-section-sub-header>
        <v-checkbox
          v-model="current_trading_model.alert_enabled"
          density="compact"
          label="Send daily email with new trades.  Requires a pro subscription"
          hide-details
        />
        <p>
          Email alerts will be sent out each trading morning. WhaleWisdom.com makes no guarantee for
          delivery of email alerts.
        </p>
      </v-col>
      <v-col cols="12">
        <helpers-section-sub-header>Realtime E-mail notifications</helpers-section-sub-header>
        <v-checkbox
          v-model="criteria.general.realtime_alert_enabled"
          density="compact"
          label="Send email in real-time with new notifications (insider and 13D/G Only).  Requires a pro subscription"
          hide-details
        />
        <p>Whalescreener will look at new insider (Form 3,4,5) and 13D/13G filings only</p>
      </v-col>
      <v-col cols="12">
        <helpers-section-sub-header>Real-time</helpers-section-sub-header>
        <v-checkbox
          v-model="criteria.general.screener_realtime"
          density="compact"
          label="Use Filing Signals From Today (excludes Trending Signals)"
          hide-details
        />
        <p>Screen will look at filings that have come in so far today.</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'
import AccessMixin from '@/mixins/access'
import api from '@/store/api'
export default {
  mixins: [AccessMixin],
  data() {
    return {
      short: false,
      loading: false,
      // stocksProxy: null,
      searchInput: null,
      searchResults: [],
      spy_tr_index: {
        name: 'S&P 500 Total Return Index',
        id: '169819',
        permalink: 'spyb',
        ticker: ['SP500TR'],
        rectype: 'stock',
        description: 'S&P 500 Total Return Index'
      }
    }
  },
  computed: {
    ...mapFields({
      criteria: 'app.whaleTraderCriteria',
      current_trading_model: 'app.current_trading_model'
    })
  },
  watch: {
    searchInput(val) {
      val && this.querySearch(val)
      this.searchInput = null
    }

    /* stocksProxy (stocksArray) {
          this.$emit('input',stocksArray);
        //this.$emit('update:stocks', stocksArray)
      } */
  },
  created() {
    //this.searchResults.push(this.spy_tr_index)
    //   this.stocksProxy=this.criteria.general.comp_index;
  },
  methods: {
    formatName(item) {
      if (!item) {
        return ''
      }
      return item.description
    },
    matchall(val) {
      return true
    },
    querySearch(val) {
      this.loading = true
      const query = `stock_autocomplete?restrictions=${this.filterInput}&keyword=${val}`
      api
        .get(query)
        .then(res => {
          this.searchResults = []
          for (var i = 0; i < res.data.length; i++) {
            var item = res.data[i]
            this.searchResults.push({ id: item.id, description: item.ticker[0] + ' ' + item.name })
          }
          // this.searchResults = res.data
          this.searchResults.push(this.spy_tr_index)
        })
        .then(() => (this.loading = false))
    }
  }
}
</script>
